import sortBy from 'lodash/sortBy';
import { useQuery } from 'react-query';

import { ModelViewSummary } from '@mpm-druid/types';
import api, { QueryConfig } from '@shared/api';

async function getModelSummaryViews({
  modelId,
  signal
}: {
  modelId: string;
  signal?: AbortSignal;
}) {
  const { data } = await api.get<ModelViewSummary[]>(
    `mpm/models/${modelId}/views`,
    { params: { summary: true }, signal }
  );

  return sortBy(data, [view => (view.is_default ? 0 : 1), view => view.name]);
}

export function useModelSummaryViews(
  { modelId }: { modelId: string },
  config?: QueryConfig<ModelViewSummary[]>
) {
  return useQuery(
    ['model-summary-views', { modelId }],
    context => {
      return getModelSummaryViews({ modelId, signal: context.signal });
    },
    {
      retry: false,
      ...config,
      enabled: (config?.enabled ?? true) && !!modelId
    }
  );
}
